import "@/App.css";
import { BrowserRouter, Routes, Route, useParams, useNavigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Home from "@/screens/Home";
import EventShell from "@/screens/EventShell";
import AuthCallback from "@/screens/AuthCallback";
import SeasonStandings from "@/screens/SeasonStandings";
import PrivacyPolicy from "@/screens/PrivacyPolicy";
import TermsOfService from "@/screens/TermsOfService";
import Profile from "@/screens/Profile";

function EventRoute() {
  const { id } = useParams();
  const navigate = useNavigate();
  return <EventShell eventId={id} onBack={() => navigate("/")} />;
}

function AppRouter() {
  const location = useLocation();
  // CRITICAL: read hash from useLocation (reactive), not window.location
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/trip/:id" element={<EventRoute />} />
      <Route path="/season" element={<SeasonStandings />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/terms" element={<TermsOfService />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" richColors theme="dark" />
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
